module.exports = __webpack_public_path__ + "static/media/LogoToca_no_Ecran.9bf5f841.png";